export function applyCentinelaLightTheme(styles, { active, state, mobile }) {
  const stateColor = state.color === '#f59e0b' ? '#a34b05'
    : ['#ef4444', '#dc2626'].includes(state.color) ? '#b91c1c'
    : state.color === '#0ea5e9' ? '#0369a1'
    : active ? '#1d4ed8' : '#54708b';
  const alert = ['#f59e0b', '#ef4444', '#dc2626'].includes(state.color);
  Object.assign(styles.overlay, {
    background: mobile ? '#f4f8fc' : 'rgba(225,236,248,0.82)'
  });
  Object.assign(styles.panel, {
    background: '#ffffff', color: '#102e54',
    border: '1px solid #d5e4f3',
    boxShadow: '0 12px 32px rgba(29,78,130,0.12)'
  });
  Object.assign(styles.close, {
    background: '#f1f6fc', color: '#123e70', border: '1px solid #cfdef0'
  });
  Object.assign(styles.heroVehicleName, { color: '#102e54' });
  Object.assign(styles.visualCard, {
    background: alert ? (state.background || 'linear-gradient(145deg,#fffbeb,#fef3c7)')
      : active ? 'radial-gradient(circle at 50% 30%,#d0eaff,#e3f2ff 55%,#f1f8ff)'
      : 'linear-gradient(145deg,#edf7ff,#e6f2ff)',
    color: '#102e54',
    border: `1px solid ${alert ? stateColor : active ? '#65b8f6' : '#b9daf8'}`,
    boxShadow: active ? '0 8px 24px rgba(37,99,235,0.16),inset 0 1px 0 #ffffff'
      : '0 5px 16px rgba(37,99,235,0.06),inset 0 1px 0 #ffffff'
  });
  Object.assign(styles.visualStateEyebrow, { color: stateColor });
  Object.assign(styles.visualStateTitle, { color: '#102e54', textShadow: 'none' });
  Object.assign(styles.visualStateDescription, { color: '#526b86' });
  Object.assign(styles.iconWrap, { background: '#edf5ff', border: '1px solid #d5e4f3' });
  Object.assign(styles.title, { color: '#102e54' });
  Object.assign(styles.subtitle, { color: '#365a7d' });
  Object.assign(styles.subtitleStrong, { color: '#607990' });
  for (const key of ['sensorsPanel', 'actionsPanel']) {
    Object.assign(styles[key], { background: '#ffffff', border: '1px solid #d5e4f3' });
  }
  Object.assign(styles.cardHeader, { color: '#4f7298' });
  Object.assign(styles.sensorItem, { borderBottom: '1px solid #e1eaf4' });
  Object.assign(styles.sensorName, { color: '#102e54' });
  Object.assign(styles.sensorStatus, { color: '#3d6084' });
  Object.assign(styles.actionButton, {
    background: '#edf5ff', color: '#164a7f', border: '1px solid #caddf4'
  });
  Object.assign(styles.mainButton, {
    background: 'linear-gradient(135deg,#12b8ec,#1261ee)', color: '#ffffff',
    border: '1px solid #179bec', boxShadow: '0 6px 16px rgba(37,99,235,0.18)'
  });
  Object.assign(styles.mainButtonOff, {
    background: 'linear-gradient(135deg,#ffffff,#eaf3ff)', color: '#164a7f',
    border: '1px solid #8dbcf0', boxShadow: '0 4px 12px rgba(37,99,235,0.10)'
  });
  Object.assign(styles.mainButtonBlocked, {
    background: 'linear-gradient(135deg,#fff8e8,#ffedcb)', color: '#92400e',
    border: '1px solid #f1c57a', boxShadow: '0 4px 12px rgba(180,83,9,0.08)'
  });
}
